import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  Icon,
  Input,
  MonthPicker,
  Text,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { IProductItem } from '../../../../sdk/products/products.types'
import { ProductDetailsContext } from '../../product-details.context'
import * as ProductDetailsStyles from '../../product-details.styles'
import { CreateProductTraceabilityModal } from '../CreateProductTraceabilityModal/create-product-traceability-modal.comp'
import { ProductItem } from '../ProductItem/product-item.comp'
import { ProductItemCard } from '../ProductItemCard/product-item-card.comp'

import * as Styles from './product-items.styles'

export const ProductItems = () => {
  const [search, setSearch] = useState('')
  const [startDate, setStartDate] = useState<Date>()
  const [endDate, setEndDate] = useState<Date>()

  const {
    productDetails,
    productItems,
    selectedItem,
    actions,
    openAddItemModal,
  } = useContext(ProductDetailsContext)

  useEffect(() => {
    actions.getItems()
  }, [])

  const fetchItems = () => {
    actions.getItems(search, startDate, endDate)
  }

  const handleSelectItem = (item: IProductItem) => {
    actions.setSelectedItem(undefined)
    setTimeout(() => {
      actions.setSelectedItem(item)
    })
  }

  const theme = useTheme()

  return (
    <ProductDetailsStyles.Card>
      <Box width="100%" gap={3} direction="column">
        <Box gap={2} width="100%" direction="column">
          <Box width="100%" justifyContent="space-between" alignItems="center">
            <Box gap={1} alignItems="center">
              <Box
                border={{
                  width: 1,
                  color: 'grey_5',
                }}
                justifyContent="center"
                alignItems="center"
                borderRadius="10px"
                width="40px"
                height="40px"
                boxShadow={theme.box_shadow.card}
              >
                <Icon name="swap2" color="primary" size={20} />
              </Box>
              <Text fontWeight={500}>Rastreabilidade</Text>
            </Box>
            <Button
              padding="12px 14px"
              onClick={() => actions.setOpenAddItemModal(true)}
            >
              <Box gap={1} alignItems="center">
                <Icon name="add" size={20} color="white" />
                <Text color="white" fontWeight={500} size="small">
                  Adicionar Rastreabilidade
                </Text>
              </Box>
            </Button>
          </Box>
          <Text color="grey_3">
            Um produto pode ter sido produzido em diferentes momentos, fábricas,
            notas fiscais ou quantidades. Cada item abaixo representa um
            registro recebido deste produto.
          </Text>
        </Box>

        <Box width="100%" gap={2} flexWrap="wrap">
          <Styles.InnerCard height="615px" flex={1} direction="column">
            <Box width="100%" gap={1} padding={2} direction="column">
              <Box width="100%" gap={1}>
                <Box flex={1}>
                  <MonthPicker
                    label="Início"
                    onChange={(month, year) => {
                      if (month && year) {
                        setStartDate(new Date(`${year}-${(month ?? 0) + 1}-01`))
                      } else {
                        setStartDate(undefined)
                      }
                    }}
                  />
                </Box>
                <Box flex={1}>
                  <MonthPicker
                    label="Fim"
                    onChange={(month, year) => {
                      if (month && year) {
                        setEndDate(new Date(`${year}-${(month ?? 0) + 1}-01`))
                      } else {
                        setEndDate(undefined)
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box width="100%" gap={1}>
                <Box flex={4}>
                  <Input
                    placeholder="Buscar por item"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    adornment={
                      <Button
                        padding="0"
                        variant="text"
                        onClick={() => setSearch('')}
                      >
                        <Icon name="close" size={16} color="grey_3" />
                      </Button>
                    }
                  />
                </Box>
                <Box flex={1}>
                  <Button onClick={fetchItems}>Filtrar</Button>
                </Box>
              </Box>
            </Box>

            <Box width="100%" flex={1} direction="column" overflow="auto">
              {productItems?.data.map((item) => (
                <ProductItem
                  key={`product-item-${item.id}`}
                  item={item}
                  selected={item.id === selectedItem?.id}
                  onSelect={handleSelectItem}
                />
              ))}
            </Box>
          </Styles.InnerCard>

          <Styles.InnerCard flex={5} height="615px" direction="column">
            <ProductItemCard />
          </Styles.InnerCard>
        </Box>
      </Box>

      <CreateProductTraceabilityModal
        open={openAddItemModal}
        itemCode={productDetails?.code ?? ''}
        onClose={() => actions.setOpenAddItemModal(false)}
        onCreated={() => actions.getItems()}
      />
    </ProductDetailsStyles.Card>
  )
}
